import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

import TableGlobalFilter from '../table-global-filter/table-global-filter.component'

import { styles } from '../../../table.styles'
import { tableMobileSearchStyles } from './table-mobile-search.styles'

const TableMobileSearch = ({
  columns,
  state,
  handleGlobalFilter,
  searchPlaceholder,
  initialValue,
  isSearchDisabled,
  searchSlot,
  searchEndAdornment,
  hasToolbarWithBorder,
  showSearchFieldBorder,
  onKeyDown,
  onSearchIconClick,
  onClearSearchRef,
  searchIconPosition,
  filterMode,
}) => {
  return (
    <Box
      sx={[
        styles.globalClientSideFilter,
        tableMobileSearchStyles.container({ hasToolbarWithBorder, showSearchFieldBorder }),
      ]}
    >
      <TableGlobalFilter
        globalFilter={state.globalFilter}
        onFilter={handleGlobalFilter}
        placeholder={searchPlaceholder}
        hasFilters={!!columns.find((item) => item.hasFilter)}
        initialValue={initialValue}
        isDisabled={isSearchDisabled}
        searchSlot={searchSlot}
        searchEndAdornment={searchEndAdornment}
        hasToolbarWithBorder={hasToolbarWithBorder}
        showSearchFieldBorder={showSearchFieldBorder}
        onKeyDown={onKeyDown}
        onSearchIconClick={onSearchIconClick}
        onClearSearchRef={onClearSearchRef}
        searchIconPosition={searchIconPosition}
        filterMode={filterMode}
      />
    </Box>
  )
}

TableMobileSearch.propTypes = {
  columns: PropTypes.array.isRequired,
  state: PropTypes.object.isRequired,
  handleGlobalFilter: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string,
  initialValue: PropTypes.string,
  isSearchDisabled: PropTypes.bool,
  hasToolbarWithBorder: PropTypes.bool,
  showSearchFieldBorder: PropTypes.bool,
  searchSlot: PropTypes.node,
  searchEndAdornment: PropTypes.node,
  searchIconPosition: PropTypes.oneOf(['start', 'end']),
  filterMode: PropTypes.string,
}

TableMobileSearch.defaultProps = {
  showSearchFieldBorder: true,
  onKeyDown: PropTypes.func,
  onSearchIconClick: PropTypes.func,
  onClearSearchRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.func }),
  ]),
}

export default TableMobileSearch
